import { HttpClient } from "@angular/common/http";
import { ApiService, BASE_URL } from "../base-service/api.service";
import { Injectable, Injector } from "@angular/core";

@Injectable()
export class VisitTrackerService extends ApiService<any, any, any> {
    urlPath: string = 'visit';
    baseUrl: string;

    constructor(private Http: HttpClient,
        private Injector: Injector
    ) {
        super(Http, Injector);
        this.baseUrl = this.Injector.get(BASE_URL);
    }

    changeVisitStatus(visitTrackerId) {
        return this.Http.patch(this.baseUrl + 'visit/status/' + visitTrackerId, {});
    }

    deleteVisit(visitTrackerId) {
        return this.Http.delete(this.baseUrl + "visit/remove/" + visitTrackerId, {});
    }
}